// extracted by mini-css-extract-plugin
module.exports = {"description":"description__1Ut8G","readMore":"readMore___f4Yd"};